import { render } from "./ConfigAccredited.vue?vue&type=template&id=73d553dd"
import script from "./ConfigAccredited.vue?vue&type=script&lang=js"
export * from "./ConfigAccredited.vue?vue&type=script&lang=js"

import "./ConfigAccredited.vue?vue&type=style&index=0&id=73d553dd&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg,QBtn});
